import Layout from "../components/Layout";
import { InboundBlotter } from "../components/_Transactions/InboundBlotter";

const InboundBlotterPage = (props: any) => {
    return (
        <Layout>
            <InboundBlotter/>
        </Layout>
    )
}

export default InboundBlotterPage